import { Box, Skeleton } from '@mui/material'
import React from 'react'

const VodContentSkeleton = ({
    rows,
    items,
}: {
    rows: number
    items: number
}) => {
    const containerStyles = {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        pt: '20px',
    }
    const skeletonStyles = {
        bgcolor: 'grey.800',
        maxWidth: '254px',
        maxHeight: '380px',
        width: '100vw',
        height: '100vh',
        mb: '20px',
        ml: '20px',
    }
    return (
        <Box sx={containerStyles}>
            {[...Array(rows).keys()].map((index) => (
                <Box key={index} display="flex" mr="20px">
                    {[...Array(items).keys()].map((index) => (
                        <Skeleton
                            sx={skeletonStyles}
                            key={index}
                            animation="wave"
                            variant="rectangular"
                        />
                    ))}
                </Box>
            ))}
        </Box>
    )
}

export default VodContentSkeleton
